import Bluebird from 'bluebird';
import { strContains } from '../../../../../services/strings';
import AutocompleteField from '../../../services/input-fields/autocomplete/autocomplete-field';
import getTranslations from '../../../services/translations';
import searchLocation from './unibar/location-search';

export default class Unibar extends AutocompleteField<API.ApiLocation> {
    constructor(id: string) {
        super(id,
            {
                search: searchLocation,
                formatValue: x => x.name,
                formatResult: result => {
                    let icon: string;
                    switch (result.type) {
                        case 'Airport':
                            icon = 'plane';
                            break;
                        case 'Trainstation':
                            icon = 'train';
                            break;
                        case 'Place':
                            icon = 'map-marker';
                            break;
                        default:
                            throw new TypeError(`Result type is unknown`);
                    }

                    // Add city and country to result
                    let nameSuffix = '';

                    if (result.type !== 'Place') {
                        if (result.city && !strContains(result.name, result.city)) {
                            nameSuffix += ', ' + result.city;
                        }
                        if (result.country) {
                            nameSuffix += ', ' + result.country;
                        }
                    }

                    // Put everything together
                    return `<span class='ac-result-icon'><i class='fa fa-${icon}' aria-hidden='true'></i></span>`
                        + `<span class='ac-result-text'><span>${result.name}${nameSuffix}</span></span>`;
                },
                addSeperator: async (before, after): Bluebird<string | undefined> => {
                    let seperator: API.ApiLocation['type'] | null = null;
                    if (!before && after
                        || before && after
                        && before.type !== after.type) {
                        seperator = after.type;
                    }

                    const t = await getTranslations('widget');
                    if (seperator) {
                        let label: string = seperator;
                        switch (seperator) {
                            case 'Airport':
                                label = t['autocomplete.airports'];
                                break;
                            case 'Place':
                                label = t['autocomplete.places'];
                                break;
                            case 'Trainstation':
                                label = t['autocomplete.trainstations'];
                                break;
                        }

                        return `<div class='ac-seperator'>${label}</div>`;
                    }
                },
                noResultMessage: async (): Bluebird<string> => {
                    return (await getTranslations('widget'))['unibar.no_results'];
                }
            },
            {
                autoSelect: true,
                resultsClass: 'ac-custom-result'
            });
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/assets/scripts/modules/widget-core/input-fields/unibar.ts